import UploadStatusComponent from '@/components/catalog/upload-popup/upload-popup.vue';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import MCIcon from '@/components/icons/mc-icon/mc-icon';
import { contentAPI } from '@/providers/apis/content-ingestion/content-ingestion';
import { sessionService } from '@/providers/services/auth/session';
import { Vue, Component } from 'vue-property-decorator';






@Component({
    name: 'request-upload',
    components: {
        'material-icon': GoogleMaterialIcon,
        'mc-icon': MCIcon,
        'upload-popup': UploadStatusComponent,
      },
  })


  export default class RequestUpload extends Vue {

    public offset = 0;
    public limit = 10;
    public currentPage = 1;
    public totalItems: number = 0;
    public dismissCountDown: number = 0;
    public uploadDetails: any = [];
    public filterDetails: any = {};
    public isLoader: boolean = false;
    public itemsId: string = '';
    public itemStatus: string = '';
    private searchText: string = '';
    private fields: any = [
      {
        key: 'index',
        label: 'S.No',
        sortable: false,
        thClass: 'text-center',
        tdClass: 'text-center',
      },

      {
        key: 'uploadDate',
        label: 'Request Uploaded Date',
        sortable: false,
        thClass: 'text-center',
        tdClass: 'text-center',
      },
      {
        key: 'resourceCount',
        label: 'Resource Counts',
        sortable: false,
        thClass: 'text-center',
        tdClass: 'text-center',
      },
      {
        key: 'processCount',
        label: 'Processed Counts',
        sortable: false,
        thClass: 'text-center',
        tdClass: 'text-center',
      },
      {
        key: 'errorCount',
        label: 'Error Counts',
        sortable: false,
        thClass: 'text-center',
        tdClass: 'text-center',
      },
      {
        key: 'status',
        label: 'Status',
        sortable: false,
        thClass: 'text-center',
        tdClass: 'text-center',
      },
    ];

    // methods
    public mounted() {
      this.getUpdateDetails();
    }

    // content-request
    public loadContent(page: number) {
      this.currentPage = page;
      const items = this.limit * this.currentPage;
      if (items >= this.uploadDetails.length) {
        this.offset = this.uploadDetails.length;
        this.limit = (this.limit * this.currentPage) - this.uploadDetails.length;
        this.filterDetails.limit = this.limit;
        this.filterDetails.offset = this.offset;
        this.getUpdateDetails();
      }
    }


  public getUpdateData() {
    this.uploadDetails = [];
    this.getUpdateDetails();
  }

    public getUpdateDetails() {
      this.isLoader = true;
      this.filterDetails.request_type = 'api';
      this.filterDetails.limit = this.limit;
      this.filterDetails.offset = this.offset;
      this.filterDetails.user_id = this.getUserId();
      contentAPI.uploadsContentRequest(this.filterDetails).then((response) => {
        this.isLoader = false;
        this.totalItems = response.count;
        this.uploadDetails = this.uploadDetails.concat(
          response.content,
        );
      });
    }

    public getTenantId() {
      const userDetails: any = sessionService.getSession();
      return userDetails.tenant.tenant_id;
    }

    public getUserId() {
      const userDetails: any = sessionService.getSession();
      return userDetails.user_id;
    }

    public passRequestData(item: any) {
      window.location.href = `/catalog?type=my-content&&id=${item.jobId}&&uploadType=request-upload`;
    }

    // Actions

      public openPopup(data: any ) {
      this.itemStatus = data.errorCount;
      this.itemsId = data.id;
      this.$bvModal.show('modal-center');
  }
  public onGoBack() {
    if (this.$router.currentRoute.query.redirectUrl === '/facet-search') {
      this.$router.push({
        path: `/facet-search`,
      });
    } else {
      this.$router.push({
        path: `/catalog`,
        query: {
          type: 'my-content',
        },
      });
    }
  }

  }

